export default __webpack_public_path__ + "static/media/play_icon.66a2b396.svg";